import { render, staticRenderFns } from "./FAQ_Dca.vue?vue&type=template&id=21911cdc&scoped=true&"
import script from "./FAQ_Dca.vue?vue&type=script&lang=js&"
export * from "./FAQ_Dca.vue?vue&type=script&lang=js&"
import style0 from "./FAQ_Dca.vue?vue&type=style&index=0&id=21911cdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21911cdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
